const CONFIRM_PATH = '/trading-platform/api/v1/risk-notification/etf/confirm';

const CONFIRM_URL = import.meta.env.DEV
  ? CONFIRM_PATH
  : `https://gateway.tenizcap.kz${CONFIRM_PATH}`;

export async function confirmRiskNotification({
  fullName,
  identificationNumber,
  language,
}) {
  const response = await fetch(CONFIRM_URL, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      fullName,
      identificationNumber,
      language,
    }),
  });

  if (!response.ok) {
    let message = 'Не удалось отправить подтверждение. Попробуйте ещё раз.';

    try {
      const data = await response.json();
      message = data?.message || data?.title || message;
    } catch {
      // Keep the default message if the response is not JSON.
    }

    throw new Error(message);
  }

  return response;
}
